import { render, staticRenderFns } from "./birthcertificate.vue?vue&type=template&id=3460eeae&"
import script from "./birthcertificate.vue?vue&type=script&lang=js&"
export * from "./birthcertificate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports